import React, { useState, useMemo, useCallback } from 'react'
import Collapsible from 'react-collapsible'

import { FontAwesomeIcon } from '@fortawesome/react-fontawesome'
import { faChevronDown, faChevronUp } from '@fortawesome/free-solid-svg-icons'

import { formatTime, getFullDateHourString } from '../../../../../utils.js'

import HistoryGrid from '../../../../../components/GridPreview'
import './index.css'
import { getDifficultySpans } from '../../../../../utils'
import useGetFilters from '../../../../../hooks/useGetAllTags'

const SubjectContainer = ({
  grile,
  timestamp,
  solvingTime,
  correctNrGrile,
  subjectName,
  books,
}) => {
  const [isTriggered, setIsTriggered] = useState(false)
  const [renderAllGrile, setRenderAllGrile] = useState(false)
  const { chapters } = useGetFilters()
  const handleConvertTagsId = useCallback(
    tagIds => {
      const tagNames = []
      for (let index = 0; index < tagIds.length; index++) {
        const tag = chapters.find(tag => tag.id === tagIds[index])
        if (tag) {
          tagNames.push(tag.name)
        }
      }
      return tagNames
    },
    [chapters],
  )

  const grids = useMemo(() => {
    return grile !== null
      ? grile?.map((grila, index) => {
          return renderAllGrile || index === 0 ? (
            <HistoryGrid
              isMultipleChoice={grila.multiple_choice}
              pagesAuto={grila.pages_auto}
              pagesManual={grila.pages_manual}
              book={{
                book_name: grila.book_name,
                book_page_offset: grila.book_page_offset,
              }}
              books={books}
              key={`history-grid-${index}`}
              historyType={1}
              grilaId={grila.id}
              cerinta={grila.json}
              timestamp={grila.timestamp}
              indiciu={grila.hint}
              explicatie={grila.explain}
              answer={grila.correct_answer}
              userAnswer={grila.choice}
              tags={handleConvertTagsId(grila.tags)}
              difficulty={getDifficultySpans(grila.difficulty)}
              source={grila.source}
            />
          ) : (
            <React.Fragment key={`empty-${index}`}></React.Fragment>
          )
        })
      : 'Loading'
  }, [grile, renderAllGrile, handleConvertTagsId, books])

  return (
    <div className="relative bg-container-background rounded sm:min-h-[140px] border border-brd-primary mt-[30px] min-h-[100px] overflow-hidden">
      <div
        onClick={() => setIsTriggered(prev => !prev)}
        className={`h-[40px] p-[10px] cursor-pointer text-white rounded-tr rounded-tl text-[11px] justify-between items-center flex font-bold sm:h-[50px] 
          ${
            correctNrGrile >= 9
              ? 'bg-correct'
              : correctNrGrile >= 7
                ? 'bg-partially-correct'
                : correctNrGrile >= 4
                  ? 'bg-partially-correct'
                  : 'bg-error'
          }`}
      >
        <div className="w-[140px] sm:text-[15px] font-bold flex justify-start items-center">
          {getFullDateHourString(new Date(timestamp * 1000))}
        </div>
        <div className="text-[15px] flex justify-center items-center ml-[20px] w-[140px]">
          {formatTime(solvingTime)}
        </div>
        <div className="text-[15px] w-[140px] flex justify-end items-center">
          {correctNrGrile} / {grile.length}
        </div>
      </div>
      <div className="text-center w-[140px]"></div>
      <div className="relative text-over-ternary-background !z-1 flex justify-center items-center md:text-[23px] text-[18px] transform translate-y-[15px]">
        {subjectName ?? 'Simulare Generată'}
      </div>
      <Collapsible
        triggerClassName="!text-over-ternary-background"
        contentInnerClassName="bg-container-background"
        open={isTriggered}
        contentOuterClassName="subject-closed-content mb-[50px]"
        trigger={
          isTriggered ? (
            <FontAwesomeIcon icon={faChevronUp} />
          ) : (
            <FontAwesomeIcon icon={faChevronDown} />
          )
        }
        onOpening={() => {
          setIsTriggered(true)
          setRenderAllGrile(true)
        }}
        onClosing={() => setIsTriggered(false)}
      >
        {grids}
      </Collapsible>
    </div>
  )
}
export default SubjectContainer
